import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-tempo-atendimento`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        autocomplete(queryParms) {
            return repository.get(`${baseUrl}/autocomplete?${urlUtil.serialize(queryParms)}`)
        },
    }
}
